import { render, staticRenderFns } from "./HouseInfo2.vue?vue&type=template&id=0e4836f6&scoped=true&"
import script from "./HouseInfo2.vue?vue&type=script&lang=js&"
export * from "./HouseInfo2.vue?vue&type=script&lang=js&"
import style0 from "./HouseInfo2.vue?vue&type=style&index=0&id=0e4836f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4836f6",
  null
  
)

export default component.exports